import { FormHelperText, TextField, type TextFieldProps } from "@mui/material";

interface InputProps extends Omit<TextFieldProps, "onChange"> {
  field: any;
  error?: boolean;
  helperText?: string;
  maxLength?: number;
  numbersOnly?: boolean;
  alphabetsOnly?: boolean;
  alphaNumericOnly?: boolean;
  allowCommonSpecialChars?: boolean;
  isDisabled?: boolean;
  toUpperCase?: boolean;
  isHint?: boolean;
  maxChar?: number;
  autoComplete?: string;
}

const Input: React.FC<InputProps> = ({
  field,
  error,
  helperText,
  maxLength,
  numbersOnly,
  alphabetsOnly,
  alphaNumericOnly,
  allowCommonSpecialChars,
  isDisabled = false,
  toUpperCase = false,
  slotProps,
  isHint = false,
  maxChar = 0,
  autoComplete,
  variant = "standard",
  ...rest
}) => {
  const hasValue = !!field?.value;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = !isHint ? e.target.value : e.target.value.slice(0, maxChar);

    if (toUpperCase) {
      value = value.toUpperCase();
    }

    if (numbersOnly) {
      value = value.replace(/[^0-9]/g, "");
    }

    if (alphabetsOnly) {
      value = value.replace(/[^A-Za-z\s]/g, "");
    }

    if (alphaNumericOnly) {
      value = value.replace(/[^A-Za-z0-9\s]/g, "");
    }

    if (allowCommonSpecialChars) {
      value = value.replace(/[^A-Za-z0-9\s\-_.\/&(),]/g, "");
    }

    if (maxLength) {
      value = value.slice(0, maxLength);
    }

    field.onChange(value);
  };

  return (
    <div>
      <TextField
        {...rest}
        variant={variant}
        fullWidth
        name={field.name}
        value={field.value ?? ""}
        onChange={handleChange}
        onBlur={field.onBlur}
        inputRef={field.ref}
        autoComplete={autoComplete}
        error={error}
        helperText={helperText}
        disabled={isDisabled}
        slotProps={{
          ...slotProps,
          inputLabel: {
            shrink: variant === "outlined" ? true : hasValue || undefined,
            ...slotProps?.inputLabel,
          },
          htmlInput: {
            maxLength,
            ...slotProps?.htmlInput,
          },
        }}
      />

      {isHint && (
        <FormHelperText style={{ textAlign: "left" }}>
          {(field.value?.length || 0)} / {maxChar}
        </FormHelperText>
      )}
    </div>
  );
};

export default Input;
